import React from 'react'
import styled from 'styled-components'
import FontAwesome from 'components/FontAwesome'

function copyToClipboard(text) {
   if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text)
   }
}

function shareOnTwitter(title) {
   // Define the content to share
   const url = window.location.href // Current page URL

   // Construct the Twitter share URL
   const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(
      url
   )}`

   // Open Twitter share dialog in a new window
   window.open(twitterUrl, '_blank', 'width=550,height=420')
}

function shareViaEmail(title) {
   const url = window.location.href
   const subject = encodeURIComponent(`Multicoin Capital: ${title}`)
   const body = encodeURIComponent(`Check out this article: ${url}`)

   // Construct mailto URL
   const mailtoUrl = `mailto:?subject=${subject}&body=${body}`

   // Open default email client
   window.location.href = mailtoUrl
}

function shareOnTelegram(title) {
   const url = window.location.href
   const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`
   window.open(telegramUrl, '_blank', 'width=550,height=420')
}

export const TelegramSocialButton = ({ title }) => (
   <ShareButton onClick={() => shareOnTelegram(title)}>
      <FontAwesome icon="paperPlane" />
   </ShareButton>
)

export const TwitterSocialButton = ({ title }) => (
   <ShareButton onClick={() => shareOnTwitter(title)}>
      <FontAwesome icon="twitter" />
   </ShareButton>
)

export const EmailSocialButton = ({ title }) => (
   <ShareButton onClick={() => shareViaEmail(title)}>
      <FontAwesome icon="emailOutline" />
   </ShareButton>
)

export const CopySocialButton = ({ postUrl }) => (
   <ShareButton onClick={() => copyToClipboard(postUrl)}>
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="16"
         height="16"
         viewBox="0 0 14 14"
         style={{
            display: 'block',
            width: '16px',
            height: '16px',
            minWidth: '16px',
            minHeight: '16px',
         }}
      >
         <path
            d="M9.9165 4.0835H7.58317V5.25016H9.9165C10.879 5.25016 11.6665 6.03766 11.6665 7.00016C11.6665 7.96266 10.879 8.75016 9.9165 8.75016H7.58317V9.91683H9.9165C11.5265 9.91683 12.8332 8.61016 12.8332 7.00016C12.8332 5.39016 11.5265 4.0835 9.9165 4.0835ZM6.4165 8.75016H4.08317C3.12067 8.75016 2.33317 7.96266 2.33317 7.00016C2.33317 6.03766 3.12067 5.25016 4.08317 5.25016H6.4165V4.0835H4.08317C2.47317 4.0835 1.1665 5.39016 1.1665 7.00016C1.1665 8.61016 2.47317 9.91683 4.08317 9.91683H6.4165V8.75016ZM4.6665 6.41683H9.33317V7.5835H4.6665V6.41683Z"
            fill="currentColor"
            strokeWidth="0"
         />
      </svg>
   </ShareButton>
)

export const ShareButton = styled.button`
   width: 32px;
   height: 32px;
   border-radius: 50%;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   background-color: ${({ theme }) => theme.colors.socialBg};
   color: ${({ theme }) => theme.colors.socialColor};
   border: 0.5px solid ${({ theme }) => theme.colors.socialBorder};
   transition: ${({ theme }) => theme.transitions.main};

   &:hover {
      background-color: ${({ theme }) => theme.colors.socialHoverBg};
      color: ${({ theme }) => theme.colors.socialHoverColor};
      border: 1px solid ${({ theme }) => theme.colors.socialHoverBorder};
   }

   &:active {
      background-color: ${({ theme }) => theme.colors.btnLightBgFocus};
   }
`
